<nav [attr.aria-labelledby]="ariaLabel()">
  <div class="row top-tasks-section">
    <div class="col-lg-8">
      <h2
        *scText="heading()"
        [attr.id]="ariaLabel()"
        class="top-tasks__heading mb-2 mb-lg-4"
      ></h2>
    </div>
  </div>
  <div class="row g-2 g-lg-4">
    <ng-content />
  </div>
</nav>
